import React, { Component } from 'react';
import variaveis from '../../styles/variaveis.css';
import { InputStyle } from './input.style';

const customStyle = {
	control: (styles, { isFocused }) => ({
		...styles,
		backgroundColor: 'white',
		borderColor: isFocused ? variaveis.selectHover : variaveis.gray300,
		boxShadow: variaveis.selectHover,
		'&:hover': {
			borderColor: variaveis.selectHover,
		},
		'textarea.form-control': '350px',
	}),
	option: (styles, { isFocused, isSelected }) => ({
		...styles,
		backgroundColor: (isSelected || isFocused) ? variaveis.selectHover : 'white',
		color: (isFocused || isSelected) ? 'white' : 'default',
		':active': {
			backgroundColor: variaveis.selectHover,
		},
	}),
};

class Input extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isFocused: false,
			currentValue: props.value,
			isLogged: false,
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
	}

	static getDerivedStateFromProps(props, state) {
		if (props.reset) {
			if (props.value !== state.currentValue) {
				return {
					currentValue: props.value,
				};
			}
		}
		return null;
	}

	handleChange(e) {
		const { onChange, checkDate } = this.props;
		if (checkDate) {
			// Caso o valor passado seja uma data que tenha o atributo de valor maximo
			// é necessario checar se o valor do input não é superior ao maximo
			// então é utilizado o atributo checkDate para essa funcionalidade
			const date = checkDate(e.target.value);
			this.setState({ currentValue: date });
		} else {
			this.setState({ currentValue: e.target.value });
		}
		if (onChange) {
			onChange(e);
		}
	}

	handleFocus(e) {
		const { onFocus } = this.props;
		this.setState({ isFocused: true });
		if (onFocus) {
			onFocus(e);
		}
	}

	handleBlur(e) {
		const { onBlur } = this.props;
		this.setState({ isFocused: false });
		if (onBlur) {
			onBlur(e);
		}
	}

	render() {
		const {
			props: { value },
			state: { currentValue },
		} = this;
		return (
			<InputStyle
				{...this.props}
				onChange={this.handleChange}
				onFocus={this.handleFocus}
				onBlur={this.handleBlur}
				value={currentValue || value}
				styles={customStyle}
			/>
		);
	}
}

export default Input;
